import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProjetoPedagogicoPage } from '../pages/projeto_pedagogico.page';

const ProjetoPedagogicoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/projeto' element={<ProjetoPedagogicoPage />} />
    </Routes>
  );
};

export { ProjetoPedagogicoRoutes };
